<template>
  <div id="experts">
    <bread :content="breadContent"></bread>
    <p class="Page-title">应急管理专家库</p>
    <el-divider></el-divider>
    <div id="content">
      <div id="cardcontent">
        <expert-card v-for="(item,index) in tableData" :key="index" :cardData="item"></expert-card>
        <el-pagination class="page" background layout="prev, pager, next,jumper" :total="cardData.length" :page-size="6" @current-change="handleCurrentChange" :current-page="tableIndex">
        </el-pagination>
      </div>
      <timeline :list="timelineData.list" :iconSrc="timelineData.iconSrc" :title="'最新专家'" :titleColor="'#0087D3'"></timeline>
    </div>
  </div>
</template>
<script>
import bread from "@/components/bread";
import expertCard from "@/components/experts/expertCard";
import timeline from "@/components/timeline";
import Api from "@/network.js";
export default {
  name: "experts",
  components: {
    bread,
    expertCard,
    timeline
  },
  async beforeRouteEnter(to, from, next) {
    let res = (await Api.experts.getExperts()) || [];
    let LastData = (await Api.index.getLast("expert_internal")) || [];
    next(vm => {
      vm.cardData = res;
      vm.tableData = vm.cardData.slice(0, 6);
      for (let item of LastData) {
        vm.timelineData.list.push({
          date: item.Date,
          content: item.Name,
          url: `/experts/detail?id=${encodeURIComponent(item.Id)}`
        });
      }
    });
  },
  data() {
    return {
      breadContent: [
        { text: "首页", routerName: "index" },
        { text: "应急管理专家库", routerName: "experts" }
      ],
      cardData: [],
      tableData: [],
      timelineData: {
        title: "最新更新",
        iconSrc: require("@/assets/blue-icon.png"),
        list: []
      },
      tableIndex: 1
    };
  },
  methods: {
    handleCurrentChange(index) {
      this.tableData = this.cardData.slice((index - 1) * 6, index * 6);
    }
  }
};
</script>
<style lang="scss" scoped>
#experts {
  width: 70%;
  margin: 0 auto;
  margin-top: 40px;
  padding: 40px 0 160px 0;
  .expertCard {
    width:100%;
    margin-top: 40px;
    padding-bottom: 20px;
    border-bottom: 1px rgb(209, 209, 209) solid;
  }
  #cardcontent {
    width: 60%;
    margin: 0 auto;
  }
  #content {
    display: flex;
    justify-content: space-around;
  }
}
.page {
  width: 100%;
  transform: scale(1.3);
  text-align: center;
  margin-top: 50px;
}
</style>

